import { CircularProgress, Paper, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

export interface LabeledValueBadgeProps {
  label?: string;
  value: string;
  loading?: boolean;
  isError?: boolean;
  sx?: SxProps<Theme>;
}

export function LabeledValueBadge({
  label,
  value,
  loading = false,
  isError = false,
  sx,
}: LabeledValueBadgeProps) {
  return (
    <Paper
      elevation={0}
      sx={[
        {
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.75,
          px: 1,
          py: 0.25,
          borderRadius: 1.5,
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'action.hover',
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {label ? (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ fontWeight: 600, whiteSpace: 'nowrap', fontSize: '0.7rem', lineHeight: 1.3 }}
        >
          {label}
        </Typography>
      ) : null}
      {loading ? (
        <CircularProgress size={12} sx={{ color: 'text.secondary' }} />
      ) : (
        <Typography
          variant="caption"
          sx={{
            fontWeight: 500,
            fontSize: '0.7rem',
            lineHeight: 1.3,
            color: isError ? 'error.main' : 'text.primary',
            whiteSpace: 'nowrap',
          }}
        >
          {value}
        </Typography>
      )}
    </Paper>
  );
}
